module.exports = "https://static.wmbcdn.com/uniweb/images/4434b1e8d2bb280b0783e43ab24f8424.webp";